/**
 * **Wem Escape gehört.**
 *
 * In der Fassung `inline` steht ein Inhalt offen in den **Aufgaben-Details**, und dort
 * schließt nichts. Escape gehört dann nicht dem Kasten, sondern der Spalte: Sie gibt die
 * Tastatur an die **Aufgabenliste** zurück (CONTEXT.md, Aufgaben-Details). Der Inhalt darf
 * die Taste deshalb weder anhalten (`stopPropagation`) noch auf sein eigenes — hier
 * leeres — `onClose` lenken. Täte er es, versickerte sie genau dort, wo der Caret
 * im Betrieb meistens sitzt: im Suchfeld des Kastens.
 *
 * In jeder anderen Fassung bleibt alles, wie es war: Escape schließt das Popover.
 *
 * Gibt `true` zurück, wenn der Griff sofort und ohne jedes Zutun aussteigen soll.
 *
 * @example
 * const handleKeyDown = (e: React.KeyboardEvent) => {
 *   if (escapeBelongsToTaskDetails(e, inline)) return
 *   e.stopPropagation()
 *   …
 * }
 */
export const escapeBelongsToTaskDetails = (e: { key: string }, inline: boolean): boolean =>
  inline && e.key === 'Escape'
